<template>
  <div class="pills-list-cell-renderer d-flex gap-2">
    <GuBadge
      v-for="item in items"
      :key="item"
      variant="light"
      pill
    >
      {{ item }}
    </GuBadge>
  </div>
</template>

<script setup>
import { computed, toRefs } from 'vue'
import { GuBadge } from '@shared/gu-components/badge'

const props = defineProps({
  params: {
    type: Object,
    default: () => ({}),
  },
})
const { params } = toRefs(props)

const items = computed(() => {
  if (!params.value.list?.length) return []

  return params.value.list.map((item) => {
    const words = item.split(' ')
    return words
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ')
  })
})
</script>
